import { AdminApi } from 'stylemix-vue-admin'

export default class BookingsApi extends AdminApi {
  constructor(parameters) {
    super('bookings', parameters)
  }

  assignForm(booking) {
    return this.submit(
      'GET',
      `${this.endpoint}/${booking.id}/assign?ride_type=${booking.ride_type}`,
    )
  }

  assign(booking, data) {
    return this.submit('PUT', `${this.endpoint}/${booking.id}/assign`, data)
  }

  accept(booking, company) {
    return this.submit('PUT', `${this.endpoint}/${booking.id}/accept`, {
      driver_id: booking.driver_id,
      vehicle_model: booking.details.vehicle_model,
      vehicle_color: booking.details.vehicle_color,
      vehicle_number: booking.details.vehicle_number,
      company_notes: booking.details.company_notes,
      company_id: company,
    })
  }

  reject(id, company, reason) {
    return this.submit('PUT', `${this.endpoint}/${id}/reject`, {
      company_id: company,
      reason,
    })
  }

  cancel(id, data) {
    return this.submit('PUT', `${this.endpoint}/${id}/cancel`, data)
  }

  complete(id) {
    return this.submit('PUT', `${this.endpoint}/${id}/complete`)
  }

  exportForm() {
    return this.submit('GET', `${this.endpoint}/export-form`)
  }

  exportUrl(params) {
    return this.submit('POST', `${this.endpoint}/export`, params)
  }

  clearPendingChanges(changesId) {
    return this.submit(
      'post',
      `${this.endpoint}/pending-changes/${changesId}/clear`,
    )
  }

  createPendingChangesInvoice(changesId) {
    return this.submit(
      'post',
      `${this.endpoint}/pending-changes/${changesId}/invoice`,
    )
  }

  acceptPriceOffer(offerId) {
    return this.submit(
      'post',
      `${this.endpoint}/price-offers/${offerId}/accept`,
    )
  }

  sendPrice(id, data) {
    return this.submit('post', `${this.endpoint}/${id}/price-offers`, data)
  }

  changeCompany(id, data) {
    return this.submit('PUT', `${this.endpoint}/${id}/change-company`, data)
  }

  updateCompanyData(id, data) {
    return this.submit(
      'PUT',
      `${this.endpoint}/${id}/update-company-data`,
      data,
    )
  }

  getDriver(id) {
    return this.submit('GET', `drivers/${id}`)
  }

  getHistory(id) {
    return this.submit('GET', `${this.endpoint}/${id}/history`)
  }

  block(id, reason) {
    return this.submit('PUT', `${this.endpoint}/${id}/block`, { reason })
  }

  setCompanyPenaltyAmount(id, amount) {
    return this.submit('PUT', `${this.endpoint}/${id}/company-penalty`, {
      penalty_amount: amount,
    })
  }
}
